import { render, staticRenderFns } from "./shenghuofuwu.vue?vue&type=template&id=54793654&scoped=true&"
import script from "./shenghuofuwu.vue?vue&type=script&lang=js&"
export * from "./shenghuofuwu.vue?vue&type=script&lang=js&"
import style0 from "./shenghuofuwu.vue?vue&type=style&index=0&id=54793654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54793654",
  null
  
)

export default component.exports